import { Icon } from "@iconify/react";
import "../styles/QuoteWorkshopInfo.css";

function QuoteWorkshopInfo({ quote }) {
  const workshop = quote.chosenOffer?.[0]?.carWorkshop;
  
  if (!workshop) return null;

  const formatPhone = (phone) => {
    if (!phone) return "";
    const cleaned = phone.replace(/\D/g, "");
    if (cleaned.length === 11) {
      return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7)}`;
    }
    if (cleaned.length === 10) {
      return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
    }
    return phone;
  };

  const formatCep = (cep) => {
    if (!cep) return "";
    const cleaned = cep.replace(/\D/g, "");
    if (cleaned.length === 8) {
      return `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`;
    }
    return cep;
  };

  const formatPrice = (price) => {
    if (!price) return "R$ 0,00";
    return `R$ ${parseFloat(price).toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  return (
    <div className="quote-workshop-card">
      <div className="quote-workshop-header">
        <Icon icon="mdi:store" className="card-icon" />
        <h2 className="card-title">Oficina Selecionada</h2>
      </div>

      <div className="quote-workshop-content">
        <div className="workshop-info-grid">
          {workshop.name && (
            <div className="workshop-info-item">
              <Icon icon="mdi:store-outline" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Nome</span>
                <span className="info-value">{workshop.name}</span>
              </div>
            </div>
          )}

          {workshop.socialReason && (
            <div className="workshop-info-item">
              <Icon icon="mdi:domain" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Razão Social</span>
                <span className="info-value">{workshop.socialReason}</span>
              </div>
            </div>
          )}

          {workshop.email && (
            <div className="workshop-info-item">
              <Icon icon="mdi:email-outline" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Email</span>
                <span className="info-value">{workshop.email}</span>
              </div>
            </div>
          )}

          {workshop.phoneNumber && (
            <div className="workshop-info-item">
              <Icon icon="mdi:phone-outline" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Telefone</span>
                <span className="info-value">{formatPhone(workshop.phoneNumber)}</span>
              </div>
            </div>
          )}

          {workshop.rating && (
            <div className="workshop-info-item">
              <Icon icon="mdi:star" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Avaliação</span>
                <span className="info-value">{workshop.rating} ⭐</span>
              </div>
            </div>
          )}

          {workshop.distance && (
            <div className="workshop-info-item">
              <Icon icon="mdi:map-marker-distance" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Distância</span>
                <span className="info-value">{workshop.distance}</span>
              </div>
            </div>
          )}

          {workshop.address && (
            <>
              <div className="workshop-info-item full-width">
                <Icon icon="mdi:map-marker" className="info-icon" />
                <div className="info-content">
                  <span className="info-label">Endereço</span>
                  <span className="info-value">
                    {workshop.address.street}, {workshop.address.number}
                    {workshop.address.complement && ` - ${workshop.address.complement}`}
                  </span>
                </div>
              </div>

              <div className="workshop-info-item">
                <Icon icon="mdi:home-city" className="info-icon" />
                <div className="info-content">
                  <span className="info-label">Bairro</span>
                  <span className="info-value">{workshop.address.district}</span>
                </div>
              </div>

              <div className="workshop-info-item">
                <Icon icon="mdi:city" className="info-icon" />
                <div className="info-content">
                  <span className="info-label">Cidade/Estado</span>
                  <span className="info-value">{workshop.address.city} - {workshop.address.state}</span>
                </div>
              </div>

              <div className="workshop-info-item">
                <Icon icon="mdi:mailbox" className="info-icon" />
                <div className="info-content">
                  <span className="info-label">CEP</span>
                  <span className="info-value">{formatCep(workshop.address.cep)}</span>
                </div>
              </div>
            </>
          )}

          {workshop.servicesIncluded && workshop.servicesIncluded.length > 0 && (
            <div className="workshop-info-item full-width">
              <Icon icon="mdi:check-circle" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Serviços Inclusos</span>
                <span className="info-value">{workshop.servicesIncluded.join(", ")}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default QuoteWorkshopInfo;
